/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Professional/Search/Content/Profiles/Content/Profile/Location"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.name',
})
let constantData = ', '
let personLocationPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.postal_address.city',
})
let constantData1 = ', '
let personLocationPostalAddressStateValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.postal_address.state',
})
let aggregateData = fromAggregate.join(personLocationNameValueData, constantData, personLocationPostalAddressCityValueData, constantData1, personLocationPostalAddressStateValueData)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 cursor="default"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconLocationOn
{...childProps}
  viewPath={`${viewPath}/TysiaIconLocationOn`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="person.location.name"
 data="', '"
 data="person.location.postal_address.city"
 data="', '"
 data="person.location.postal_address.state"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}